import { format } from 'date-fns';
function getBasicDate(date) {
  return format(date, 'yyyy-MM-dd');
}
export default getBasicDate;